import { render, staticRenderFns } from "./Bookings.vue?vue&type=template&id=22ab0455&scoped=true&"
import script from "./Bookings.vue?vue&type=script&lang=ts&"
export * from "./Bookings.vue?vue&type=script&lang=ts&"
import style0 from "./Bookings.vue?vue&type=style&index=0&id=22ab0455&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ab0455",
  null
  
)

export default component.exports